type BoundaryListener = (boundaries: number[]) => void;

const boundariesByLocalId = new Map<string, number[]>();
const listenersByLocalId = new Map<string, Set<BoundaryListener>>();

export function setRowBoundaries(localId: string, boundaries: number[]): void {
	boundariesByLocalId.set(localId, boundaries);
	const listeners = listenersByLocalId.get(localId);
	if (!listeners) {
		return;
	}
	for (const listener of listeners) {
		try {
			listener(boundaries);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(`[row-boundaries-store] listener for "${localId}" threw:`, error);
		}
	}
}

export function getRowBoundaries(localId: string): number[] | undefined {
	return boundariesByLocalId.get(localId);
}

export function clearRowBoundaries(localId: string): void {
	boundariesByLocalId.delete(localId);
	listenersByLocalId.delete(localId);
}

export function subscribeRowBoundaries(localId: string, listener: BoundaryListener): () => void {
	let listeners = listenersByLocalId.get(localId);
	if (!listeners) {
		listeners = new Set();
		listenersByLocalId.set(localId, listeners);
	}
	listeners.add(listener);
	return () => {
		const set = listenersByLocalId.get(localId);
		if (!set) {
			return;
		}
		set.delete(listener);
		if (set.size === 0) {
			listenersByLocalId.delete(localId);
		}
	};
}

export function __resetRowBoundariesStoreForTests(): void {
	boundariesByLocalId.clear();
	listenersByLocalId.clear();
}
